import type { UserBannerDataResponse } from 'hb-builder/api/userBanner/types';
import type { UserBannerChildren } from 'hb-builder/components/BuilderComponents/page/block/UserBanner/types/UserBannerChildren';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const newButton = (button: ItemAttributes, userId: number) => {
  const {
    attributes: { buttonLink },
  } = button;

  return {
    ...button,
    attributes: {
      ...button.attributes,
      buttonLink: buttonLink?.replace('%{User_ID}', userId),
    },
  };
};

export const getFormattedChildren = ({
  item,
  profileCompletionRate,
  user,
}: {
  item?: DocumentItem<SectionItemAttributes>;
  profileCompletionRate: number;
  user?: UserBannerDataResponse;
}): Record<
  | 'buttonAccount'
  | 'buttonEvent'
  | 'buttonPortfolio'
  | 'buttonPost'
  | 'image'
  | 'headline'
  | 'profileCompletion',
  ItemAttributes
> => {
  const itemChildren = item?.children as UserBannerChildren;
  const [
    image,
    headline,
    buttonPost,
    buttonEvent,
    buttonPortfolio,
    buttonAccount,
    profileCompletion,
  ] = itemChildren;

  const newProfileCompletion: ItemAttributes = {
    ...profileCompletion,
    content: __('Profile completed %{percentage}%').i__({
      percentage: String(profileCompletionRate),
    }),
  };

  if (!user) {
    return {
      buttonAccount,
      buttonEvent,
      buttonPortfolio,
      buttonPost,
      headline,
      image,
      profileCompletion: newProfileCompletion,
    };
  }

  const newImage = {
    ...image,
    attributes: {
      ...image.attributes,
      url: user.photo_url,
    },
  };

  const newHeadline = user
    ? {
        ...headline,
        content: headline.content
          ?.replace('%{First_Name}', user.firstname)
          ?.replace('%{Last_Name}', user.lastname),
      }
    : headline;

  return {
    buttonAccount: newButton(buttonAccount, user.id),
    buttonEvent: newButton(buttonEvent, user.id),
    buttonPortfolio: newButton(buttonPortfolio, user.id),
    buttonPost: newButton(buttonPost, user.id),
    headline: newHeadline,
    image: newImage,
    profileCompletion: newProfileCompletion,
  };
};
